/**
 * Message shown in the public quote's "expired" banner.
 *
 * The dated variant ("This quote expired on <date>…") must only appear when the
 * merchant allows the valid-until date to be shown (the design's `validUntil` field).
 * When the date is hidden — or absent — we fall back to a generic message so the
 * valid-until date never leaks onto customer-facing output. Extracted as a pure
 * function so the visibility gate is unit-testable independently of the large
 * public quote route component.
 */
export function expiredQuoteMessage(args: {
  validUntil: string | null | undefined;
  /** `layoutVisibility(design).validUntil` — whether the valid-until date may be shown. */
  showValidUntil: boolean;
  formatDate: (value: string) => string;
}): string {
  const { validUntil, showValidUntil, formatDate } = args;
  if (showValidUntil && validUntil) {
    return `This quote expired on ${formatDate(validUntil)}. Please contact us for an updated estimate.`;
  }
  return 'This quote has expired. Please contact us for an updated estimate.';
}
